import { service } from ".";

export default {
  getAll: () => service.get("/vacancies"),
  getOne: (id) => service.get(`/vacancies/${id}`),
  getAllPaginate: (query) => service.get(`/vacancies/paginate?${query}`),
  create: (data) => service.post("/vacancies", data),
  update: (id, data) => service.put(`/vacancies/${id}`, data),
  delete: (id) => service.delete(`/vacancies/${id}`),
};
